<div class="exchange-log table-wrapper">
    <aumico-table [options]="tableOptions" [data]="data" [delegate]="this"> </aumico-table>
</div>
